// NOTE: This component requires recharts to be installed
// Run: npm install recharts --legacy-peer-deps

import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

interface BarChartWidgetProps {
  title: string;
  data: any[];
  xKey: string;
  yKey: string;
  yLabel?: string;
  color?: string;
  height?: number;
  layout?: "horizontal" | "vertical";
}

const BarChartWidget: React.FC<BarChartWidgetProps> = ({
  title,
  data,
  xKey,
  yKey,
  yLabel,
  color = "#82ca9d",
  height = 300,
  layout = "horizontal",

}) => {
  console.log("data", data);
  return (
    <Paper elevation={3} sx={{ p: 2, height: "100%" }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Box sx={{ width: "100%", height: height }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout={layout}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            {layout === "horizontal" ? (
              <>
                <XAxis dataKey={xKey} />
                <YAxis />
              </>
            ) : (
              <>
                <XAxis type="number" />
                <YAxis dataKey={xKey} type="category" />
              </>
            )}
            <Tooltip />
            <Legend />
            <Bar dataKey={yKey} fill={color} name={yLabel || yKey} />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default BarChartWidget;
